// HistoryPanel.jsx

import React, { useEffect, useState, useMemo } from "react";
import { loadHistory } from "../api/reportApi";

function formatGroupDate(dateString) {
    if (!dateString) return "Unknown date";
    const datePart = dateString.split(" ")[0];
    const today = new Date();
    const todayStr = today.toISOString().slice(0, 10);
    const yesterday = new Date();
    yesterday.setDate(yesterday.getDate() - 1);
    const yesterdayStr = yesterday.toISOString().slice(0, 10);
    if (datePart === todayStr) return "Today";
    if (datePart === yesterdayStr) return "Yesterday";
    return datePart;
}

export default function HistoryPanel({ onSelectJob, setLoading, refreshKey, user, collapsible = false }) {
    const [history, setHistory] = useState([]);
    const [activeJobId, setActiveJobId] = useState(null);
    const [collapsed, setCollapsed] = useState(true);

    useEffect(() => {
        let cancelled = false;

        const load = async () => {
            const jobId = refreshKey?.split(":")[0] || null;

            for (let attempt = 0; attempt < 5; attempt++) {
                try {
                    const data = await loadHistory();
                    const items = Array.isArray(data) ? data : [];
                    if (!cancelled) setHistory(items);

                    if (!jobId || items.some(repo => repo.jobId === jobId)) return;
                } catch (e) {
                    if (!cancelled) console.warn("Failed to load history", e);
                }

                await new Promise(resolve => setTimeout(resolve, 500));
            }

            if (!cancelled) {
                try {
                    const data = await loadHistory();
                    setHistory(Array.isArray(data) ? data : []);
                } catch (e) {
                    console.warn("Final history load failed", e);
                }
            }
        };

        load();
        return () => { cancelled = true; };
    }, [refreshKey]);

    const handleSelect = (repo) => {
        setActiveJobId(repo.jobId);
        onSelectJob(repo.jobId);
        if (setLoading) setLoading(true);
    };

    const groupedHistory = useMemo(() => {
        const groups = {};

        history.forEach(repo => {
            const createdAt = repo.createdAt || "";
            const dateKey = createdAt.split(" ")[0] || "Unknown";
            if (!groups[dateKey]) groups[dateKey] = [];
            groups[dateKey].push(repo);
        });

        return Object.entries(groups).sort((a, b) => b[0].localeCompare(a[0]));
    }, [history]);

    return (
        <aside className={`custor-history ${collapsible ? "history-collapsible" : ""} ${collapsible && collapsed ? "history-collapsed" : ""}`}>
            <div
                className="history-title"
                onClick={() => {
                    if (collapsible) setCollapsed(value => !value);
                }}
                style={{ cursor: collapsible ? "pointer" : "default" }}
            >
                HISTORY {collapsible && (collapsed ? "▾" : "▴")}
            </div>

            <div style={{
                fontSize: "12px",
                color: "#999",
                marginBottom: "12px",
                wordBreak: "break-word"
            }}>
                {user?.email || ""}
            </div>

            {(!collapsible || !collapsed) && (
                <>

            {groupedHistory.length === 0 && <div>No reports yet.</div>}

            {groupedHistory.map(([dateKey, repos]) => (
                <div key={dateKey} style={{ marginBottom: "14px" }}>
                    <div style={{
                        fontSize: "12px",
                        color: "#888",
                        fontWeight: 600,
                        marginBottom: "6px",
                        paddingBottom: "4px",
                        borderBottom: "1px solid #222"
                    }}>
                        {formatGroupDate(dateKey)}
                    </div>

                    {repos.map(repo => {
                        const time = repo.createdAt?.split(" ")[1] || "";

                        return (
                            <div
                                key={repo.jobId}
                                className={`history-item ${activeJobId === repo.jobId ? "active" : ""}`}
                                onClick={() => handleSelect(repo)}
                            >
                                <div className="repo-name">{repo.repoName}</div>
                                <div className="repo-date">{time}</div>
                            </div>
                        );
                    })}
                </div>
            ))}

                </>
            )}

        </aside>
    );
}